import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { useLocation, useParams } from 'react-router-dom';
import DefaultLayout from 'components/layout/DefaultLayout';
import { storyApi } from 'apis/story/storyApis';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { useTranslation } from 'react-i18next';
import MinicutUpdateWrapper from './MinicutUpdateWrapper';
import { minicutApi } from 'apis/resource/minicutApis';
import { handleMessage } from 'utils/helper/message';
import { useAppDispatch } from 'hooks/redux';
import { setEditName, setStoryName } from 'store/slices/breadcumbSlice';
import { useCookies } from 'react-cookie';
import { IMinicut } from 'utils/types/resourceTypes';
/**
 * * 리소스 - 미니컷 수정 페이지
 */

const MinicutUpdatePage = () => {
  const dispatch = useAppDispatch();
  const { state } = useLocation();
  const [cookies] = useCookies();
  const { projectId, minicutId } = useParams();
  const { t } = useTranslation();

  const [data, setData] = useState<IMinicut | null>(null);
  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);

  // 진입시 실행
  const handleFetchData = async () => {
    if (!projectId || !minicutId) {
      handleMessage(message, 'error', '잘못된 진입입니다.');
      return;
    }

    console.log(`state : `, state);

    if (projectId) {
      try {
        const storyDetailData = await storyApi.storyDetail(projectId);
        const minicutRes = await minicutApi.minicutList(projectId.toString());
        const detailMinicut = minicutRes.list.find(
          (e) => e.id === Number(minicutId),
        );
        const langRes = await storyApi.supportLang();
        setData(detailMinicut);
        setSupportLangList(langRes);
        dispatch(setEditName(detailMinicut.image_name));

        const episodeName = storyDetailData?.project?.projectDetails?.find(
          (e) => e.lang === cookies.lang,
        );
        dispatch(
          setStoryName(episodeName ? episodeName.title : storyDetailData.title),
        );
      } catch (err) {
        handleMessage(message, 'error', 'Call api error');
      }
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <DefaultLayout>
      <MinicutUpdateWrapper
        data={data}
        setData={setData}
        supportLangList={supportLangList}
      />
    </DefaultLayout>
  );
};

export default MinicutUpdatePage;
